type Constructor<T = {}> = new (...args: any[]) => T

export const wrapSingleton = <T>(target: Constructor<T>) => {
  let instance: T | null = null

  return (): T => {
    if (instance) {
      return instance
    }

    instance = new target()

    return instance
  }
}
